import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import { QuickViewPopup } from '~js/components/quick-view-popup';


export class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      if (this.hasAttribute(a.attributes$7.url) && this.getAttribute(a.attributes$7.url) !== '') {
        fetch(this.getAttribute(a.attributes$7.url))
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(s.selectors$9.complementaryProducts);

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector(s.selectors$9.buttonQuickView)) {
              new QuickViewPopup(this);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}